export const BREAKPOINTS = {
	SMALL_MOBILE: '(max-width: 480px)',
	MOBILE: '(max-width: 767px)',
	TABLET: '(min-width: 768px) and (max-width: 991px)',
	SMALL_DESKTOP: '(min-width: 992px) and (max-width: 1199px)',
	DESKTOP: '(min-width: 1200px)',
	NOT_DESKTOP: '(max-width: 1200px)'
} as const;
